<template>
  <div>
    <doe-label :name="name">
      {{ label }}
    </doe-label>
    <input
      autocomplete="off"
      type="number"
      :name="name"
      :id="name"
      :value="value"
      :placeholder="placeholder"
      :aria-describedby="hint ? ariaDescID : false"
      @input="$emit('input', $event.target.value)"
      maxlength="80"
    />
    <doe-error v-if="errors.has(name)">{{ errors.first(name) }}</doe-error>
    <doe-hint :hint="hint" :description="ariaDescID" />
  </div>
</template>

<script>
import DoeLabel from "@/components/field/Label";
import DoeHint from "@/components/field/Hint";
import DoeError from "@/components/field/Error";

export default {
  name: "DoeNumber",
  inject: {
    $validator: "$validator"
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    hint: {
      type: [Array, String]
    }
  },
  components: {
    DoeLabel,
    DoeHint,
    DoeError
  },
  computed: {
    ariaDescID() {
      return `${this.name}Description`;
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  @apply bg-gray-300 border border-gray-800 rounded font-sans leading-snug max-w-md px-3 py-2 subpixel-antialiased text-gray-900 text-xl w-full;
  &:hover {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
  }
  &:focus {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
}
</style>
